<template>
  <v-layout row wrap>
    <v-flex>
      <v-container fluid class="pa-3 ma-0">
        <div style="padding-left: 24px; padding-right: 24px; font-size: 20px; font-weight: 500; letter-spacing: 0.02em;">Organization Chart</div>
        <div id="myChart" style="width: 100%; height: 1200px;" class="rey lighten-5"></div>
      </v-container>
    </v-flex>
  </v-layout>
</template>


<script>
import auth from "../../functions/auth";
// import PageLayout from "../myDesk/myDesk_layout";
import common from "../../functions/general";
import echarts from "echarts";

export default {
  name: "OrgChart",
  // components: {
  //   PageLayout: PageLayouts
  // },
  data: () => ({
    username: "",
    // parent_page_id: 37, // makesure hrm_page id set correctly for LIVE
    // cards: [],
    chart_data: []
  }),
  async mounted() {
		// auth.hideHeader(true);
		// auth.hideFooter(true);
    this.username = auth.getUsername();
    
    let result = await common.wBackEndComm.PostData("org_chart/org_chart_tree/");

    if (result.data.Status == 1) {
      this.chart_data = result.data.Body;
    } else {
      common.wMsgBox.Error(result.data.Description);
    }
    
    var myOrg = echarts.init(document.getElementById("myChart"));
    var option = {
      tooltip: {
        textStyle: {
          fontSize: 10,
        },
        formatter: function(params) {
          var data = params.data;
          
          var temp = ["<b>" + data.name + "</b>"];
          var return_value="";
          var length=data.hods.length;

          for (var i = 0, m=length; i<m; i++) {
            temp.push("<li> (HOD) " + data.hods[i].hod_name + "</li>");
          }

          if(temp.length>0){
            return_value = "<ul>" + temp.join("") + "</ul>"
          }

          return return_value;
        }
      },
      series: [
        {
          expandAndCollapse: true,
          initialTreeDepth: 1,
          type: "tree",
          id: 0,
          name: "tree1",
          data: this.chart_data,

          top: "10%",
          left: "8%",
          bottom: "22%",
          right: "20%",

          symbolSize: 10,

          edgeShape: "polyline",
          edgeForkPosition: "50%",

          lineStyle: {
            width: 2
          },

          label: {
            backgroundColor: "rgba(255, 255, 255, 0.7)",
            position: "left",
            verticalAlign: "middle",
            align: "right",
            formatter: function (a) {
              var data = a.data;
              
              var length_hod = data.hods.length;
              var length_emp = data.employees.length;

              var temp = [data.name + " [" + length_emp + "]"];
              var return_value="";

              for (var j = 0, n = length_hod; j<n; j++) {
                temp.push("(HOD) " + data.hods[j].hod_name);
              }

              for (var i = 0, m = length_emp; i<m; i++) {
                temp.push(data.employees[i].emp_name);
              }

              if(temp.length>0){
                return_value = temp.join("\n • ");
              }

              return return_value;
            }
          },

          leaves: {
            label: {
              position: "right",
              verticalAlign: "middle",
              align: "left"
            },
            itemStyle: {
              color: "#c33e3a",
              // borderWidth: 3.0
            }
          },

          animationDuration: 550,
          animationDurationUpdate: 750
        }
      ]
    };

    myOrg.setOption(option);

    // myOrg.on("click",function(e){
    //   console.log(e);
    // });
  },
  methods: {
    // btn_onClick(url) {
    //   this.$router.push({ path: url });
    // }
  }
};
</script>


<style>
</style>